import { defineStore } from 'pinia';
import contactApi from "@/api/contactApi.js";

export const useContactsStore = defineStore('contactsStore', {
    state: () => ({}),


    actions: {
        async loadContacts({ target, id, page = 1, search = '', filters = {} }) {
            try {
                const params = { target, id, page, filters };
                if (search) {
                    params.q = search;
                }
                return await contactApi.list(params);
            } catch (error) {
                console.error('Ошибка загрузки контактов:', error);
                throw error; // Пробрасываем ошибку для обработки в компоненте
            }
        },
        // Общий список с фильтрами по связанным сущностям
        async loadContactsList({ page = 1, search = '', customer, facility, contract, work } = {}) {
            try {
                return await contactApi.list({
                    page,
                    q: search || undefined,
                    customer,
                    facility,
                    contract,
                    work,
                });
            } catch (error) {
                console.error('Ошибка загрузки общего списка контактов:', error);
                throw error;
            }
        },

        async createContact(data) {
            try {
                return await contactApi.create(data);
            } catch (error) {
                console.error('Ошибка создания контакта:', error);
                throw error;
            }
        },

        async linkContact(contactId, linkBody) {
            try {
                return await contactApi.link(contactId, linkBody);
            } catch (error) {
                console.error('Ошибка привязки контакта:', error);
                throw error;
            }
        },

        async updateContact(id, data) {
            try {
                return await contactApi.update(id, data);
            } catch (error) {
                console.error('Ошибка обновления контакта:', error);
                throw error;
            }
        },
        async deleteContact(id) {
            try {
                return await contactApi.delete(id);
            } catch (error) {
                console.error('Ошибка удаления контакта:', error);
                throw error;
            }
        },


    },

});